export const CameraModes = {
  Rear: 'environment',
  Front: 'user',
} as const;

export type CameraModeType = (typeof CameraModes)[keyof typeof CameraModes];
